import lazyLoadOnRender from '../../lazy/loadOnRender';

const loader = () => import(/* webpackChunkName: "4-feat-live-persona-card" */ './LivePersonaCardErrorBoundary');

export default lazyLoadOnRender({ loader });
